export const zestRoutes = {
    calculator: '/emi-calculator',
    calculator_v1: '/emi-calculator/v1',
    health: '/emi-calculator/health',
};
